<script>
  import Icon from "@shared/svelte/Components/Icon.svelte";

</script>

<button on:click class="fizz-icon-button">
  <Icon type="MenuSmall" extraClassNames="fizz-icon-32 fizz-text-brand" />
</button>
